import api from '@/utils/http/axios'
import { NO_PREFIX_URL } from '@/utils/http/base-url'

export default {
  /**
  * 获取权限菜单
  * @param {string} cstId 客户号
  * @param {string} userId 用户号
  * @param {boolean} needToken 是否需要token 设置为true
  */
  getTaskTree (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/taskTree1.do`, params, config, 'URLEncoded')
  }
}
